import {
    provincial_ltt,
    municipal_ltt,
    ltt_rebate,
    total_ltt,
} from '@ratehub/mortgage-calculations';


const calculationStrategies = {
    landTransferTax: landTransferTaxCalculation,
    provincialTax: provincialTaxCalculation,
    municipalTax: municipalTaxCalculation,
    rebate: rebateCalculation,
};

function getLandTransferTaxCalculations(values, type) {
    const calculation = calculationStrategies[type];

    return calculation(values);
}

function landTransferTaxCalculation({ homePrice, homeLocation, isFirstTimeBuyer, isNewlyBuiltHome }) {
    return homeLocation?.province?.code && homeLocation?.name && homePrice && isFirstTimeBuyer !== null && isNewlyBuiltHome !== null
        ? total_ltt(homePrice, homeLocation?.province?.code, homeLocation?.name, isFirstTimeBuyer, isNewlyBuiltHome)
        : null;
}

function provincialTaxCalculation({ homePrice, homeLocation }) {
    return homeLocation?.province?.code && homePrice
        ? provincial_ltt(homeLocation.province.code, homePrice)
        : null;
}

function municipalTaxCalculation({ homePrice, homeLocation }) {
    return homeLocation?.province?.code && homeLocation?.name && homePrice
        ? municipal_ltt(homeLocation.province.code, homeLocation?.name, homePrice)
        : null;
}

function rebateCalculation({ homePrice, homeLocation, isFirstTimeBuyer = false, isNewlyBuiltHome = false }) {
    return homeLocation?.province?.code && homeLocation?.name && homePrice && isFirstTimeBuyer !== null && isNewlyBuiltHome !== null
        ? ltt_rebate(homeLocation.province.code, homeLocation?.name, homePrice, isFirstTimeBuyer, isNewlyBuiltHome)
        : null;
}

export default getLandTransferTaxCalculations;